import { chatEvent } from '@/domains/common/api';
import { defineRouteDef, z } from '@/domains/common/api';

export const globalChatRoute = defineRouteDef({
  method: 'POST',
  path: '/api/global-chat',
  audience: 'user',
  body: z.object({
    body: z.string().min(1),
    auto_confirm: z.boolean().optional(),
    current_page: z.string().optional(),
    screen_context: z.string().optional(),
  }),
  events: chatEvent,
});

export const globalChatMessage = z.object({
  id: z.string(),
  role: z.enum(['user', 'agent']),
  agent: z.string().nullable(),
  body: z.string(),
  actions: z.unknown(),
  created_at: z.string(),
});
export type GlobalChatMessage = z.infer<typeof globalChatMessage>;

export const globalChatThreadRoute = defineRouteDef({
  method: 'GET',
  path: '/api/global-chat',
  audience: 'user',
  query: z.object({}),
  output: z.object({ messages: z.array(globalChatMessage) }),
});

export const clearGlobalChatRoute = defineRouteDef({
  method: 'DELETE',
  path: '/api/global-chat',
  audience: 'user',
  body: z.object({}),
  output: z.object({ ok: z.literal(true), deleted: z.number() }),
});
